import { render, staticRenderFns } from "./UserStatistics.vue?vue&type=template&id=1766b375&scoped=true"
import script from "./UserStatistics.vue?vue&type=script&lang=js"
export * from "./UserStatistics.vue?vue&type=script&lang=js"
import style0 from "./UserStatistics.vue?vue&type=style&index=0&id=1766b375&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1766b375",
  null
  
)

export default component.exports